import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=d3bbedca&"
import script from "./addresses.vue?vue&type=script&lang=js&"
export * from "./addresses.vue?vue&type=script&lang=js&"
import style0 from "./addresses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3bbedca')) {
      api.createRecord('d3bbedca', component.options)
    } else {
      api.reload('d3bbedca', component.options)
    }
    module.hot.accept("./addresses.vue?vue&type=template&id=d3bbedca&", function () {
      api.rerender('d3bbedca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/addresses.vue"
export default component.exports